import { ArticleHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IKeyValTableProps {
  title?: string | null;
  className?: string;
  table: Array<{ title: React.ReactElement<any> | number | string; value: React.ReactElement<any> | number | string }>;
  size?: 'M' | 'XS';
}

export const KeyValTable: React.FC<IKeyValTableProps> = ({ table, className, size, title }) => {
  const Text = size === 'M' ? UIText1 : UIText2;

  return (
    <div className={cn(styles['container'], className)}>
      {title && <ArticleHeading4 as="P">{title}</ArticleHeading4>}

      <div className={styles['wrapper']}>
        {table.map(({ title, value }) => (
          <React.Fragment key={String(title)}>
            <Text color="gray60_100">{title}</Text>
            <Text>{value}</Text>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
